import theme from ".";

const typography = {
  fontFamily: ['Work Sans', 'Inter', 'sans-serif'].join(','),
  h1: {
    fontSize: '2.1875rem',
    color: '#1070b3',
  },
  h2: {  
    fontSize: '2.1875rem',
    color: '#1070b3'
  },
  h3: {
    fontSize: '1.25rem',
    color: 'white'
  },
  h4: {
    fontSize: '1.3125rem',
  }
  
};
export default typography;
